'use strict';

((window, document, $) => {
$('#vote-slider').slick({
    rows: 7,
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                rows: 4,
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }
    ]
});

})(window, document, jQuery);